const d3 = require("d3");
const { DashboardVisual } = require("@/visualisation/dashboard/dashboardVisual.js");

class FinancialVisual extends DashboardVisual {
    constructor(svg, currData) {
        
        super(svg);

        this.initChart(currData);

        
    }

    getBaseOpacities() {
        return [1.0, 1.0, 1.0];
    }

    valToString(val) {
        this.moneyFormatter = Intl.NumberFormat('en', { notation: 'compact'});
        
        return this.moneyFormatter.format(val);
    }

    getBaseColours() {
        return ["rgb(255, 102, 127)", "rgb(255, 210, 102)",  "rgb(102, 188, 255)"];
    }

    initChart(currData) {

        super.initChart(this.getBaseOpacities(), this.getBaseColours(), currData.pieData);

        this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", -48).text("Profit, $").style("font-family", "Open Sans").style("font-size", "17px").style("font-weight", "400").style("fill", "rgba(74, 74, 74, 1)");
        this.profitText = this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", -13).text("330k").style("font-family", "Open Sans").style("font-size", "40px").style("font-weight", "600").style("fill", "rgba(110, 188, 44, 1)");

        // Add one word in the middle of the circle, with the open sans font

        this.chart.append("text").attr("text-anchor", "middle").attr("dy", ".35em").attr("y", 22).text("Costs / Revenue, $").style("font-family", "Open Sans").style("font-size", "17px").style("font-weight", "400").style("fill", "rgba(74, 74, 74, 1)");
        this.costRevenue = this.chart.append("text").classed("costRevenue", true);
        this.costRevenue.attr("text-anchor", "middle").attr("dy", ".35em").attr("y", 45).text("730k / 1060k").style("font-family", "Open Sans").style("font-size", "17px").style("font-weight", "600").style("fill", "rgba(74, 74, 74, 1)");

        this.updateChart(currData);
    }

    updateChart(currData) {
        var cost = this.moneyFormatter.format(currData.totalCost);
        var revenue = this.moneyFormatter.format(currData.projectRevenue);

        this.costRevenue.text(cost + " / " + revenue);
        this.profitText.text(this.moneyFormatter.format(currData.projectRevenue - currData.totalCost));



        this.profitText.style("fill", currData.projectRevenue - currData.totalCost >= 0 ? "rgba(110, 188, 44, 1)" : "rgba(236, 74, 67, 1)");

        super.updatePie(currData.pieData);
    }
}

export { FinancialVisual };